<template>
<div class="chapter">
<div class="inner_page">
<div class="group_image">
<p class="image"><a id="page_xv"><img alt="image1" src="images/image001.jpg"/></a></p><a id="page_xv">
</a><p class="caption" id="fm"><a id="page_xv"></a><a href="#/xhtml/contents#fm"><b>Europe at the beginning of World War I</b></a></p>
</div>
<div class="group_image">
<p class="image"><img alt="image1a" src="images/image001a.jpg"/></p>
<p class="caption"><a href="#/xhtml/contents#fm"><b>Europe during World War II (1942)</b></a></p>
</div>
<div class="group_image">
<p class="image"><a id="page_xvi"><img alt="image" src="images/image002.jpg"/></a></p><a id="page_xvi">
<p class="caption"><b>Post–World War II Germany</b></p>
</a></div><a id="page_xvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustration.vue?2c67e59e